import { goalsFilterBarConfig } from './filterBars';

import type { LayoutPageConfig } from './types';

export const goalsPageConfig = {
  namespacesRequired: ['goals', 'tables'],
  layout: {
    filterBar: goalsFilterBarConfig,
    showHeaderPeriodFilter: false,
  },
} satisfies LayoutPageConfig;
